/* ============================================================
   NOVAA GEAR — Customer Cars
   Live search filter (make + model) + inline media viewer.
   Loaded for: page template suffix "customer-cars".
   No dependencies. Safe to load with `defer`.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__ccInit) return;
    root.__ccInit = true;

    var input    = root.querySelector('[data-cc-search]');
    var clearBtn = root.querySelector('[data-cc-clear]');
    var result   = root.querySelector('[data-cc-result]');
    var chipWrap = root.querySelector('[data-cc-chips]');
    var gallery  = root.querySelector('[data-cc-gallery]');
    var empty    = root.querySelector('[data-cc-empty]');
    var emptyQ   = root.querySelector('[data-cc-empty-q]');
    if (!gallery) return;

    var groups = Array.prototype.slice.call(gallery.querySelectorAll('[data-cc-group]'));

    /* -------- per-group counts + jump chips (built from the DOM) -------- */
    groups.forEach(function (g) {
      var tiles = g.querySelectorAll('[data-cc-tile]');
      var vids  = g.querySelectorAll('[data-cc-tile][data-type="video"]').length;
      var countEl = g.querySelector('[data-cc-count]');
      if (countEl) {
        countEl.innerHTML = '<b>' + tiles.length + '</b> media' +
          (vids ? ' · <b>' + vids + '</b> video' + (vids > 1 ? 's' : '') : '');
      }
      if (chipWrap) {
        var label = g.getAttribute('data-chip-label') || g.getAttribute('data-model') || '';
        var q = g.getAttribute('data-model') || '';
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'cc-chip';
        chip.setAttribute('data-q', q);
        chip.innerHTML = label + ' <span class="n">' + tiles.length + '</span>';
        chipWrap.appendChild(chip);
      }
    });

    /* -------- live search -------- */
    function applyFilter(raw) {
      var q = (raw || '').trim().toLowerCase();
      var terms = q ? q.split(/\s+/) : [];
      var shownGroups = 0, shownPhotos = 0, shownVideos = 0;

      groups.forEach(function (g) {
        var hay = (g.getAttribute('data-cc-keywords') || '').toLowerCase();
        var match = terms.every(function (t) { return hay.indexOf(t) !== -1; });
        g.hidden = !match;
        if (match) {
          shownGroups++;
          g.querySelectorAll('[data-cc-tile]').forEach(function (t) {
            if (t.getAttribute('data-type') === 'video') shownVideos++; else shownPhotos++;
          });
        }
      });

      if (empty) empty.classList.toggle('show', shownGroups === 0);
      if (shownGroups === 0 && emptyQ) emptyQ.textContent = raw;

      if (result) {
        result.innerHTML = (shownGroups === 0)
          ? '<b>0</b> results'
          : '<b>' + shownPhotos + '</b> photos · <b>' + shownVideos + '</b> videos · <b>' +
            shownGroups + '</b> model' + (shownGroups === 1 ? '' : 's');
      }
      if (clearBtn) clearBtn.hidden = !q;

      if (chipWrap) {
        chipWrap.querySelectorAll('.cc-chip').forEach(function (c) {
          c.classList.toggle('is-on', (c.getAttribute('data-q') || '').toLowerCase() === q);
        });
      }
    }

    if (input) input.addEventListener('input', function () { applyFilter(input.value); });
    if (clearBtn) clearBtn.addEventListener('click', function () {
      if (input) { input.value = ''; input.focus(); }
      applyFilter('');
    });
    if (chipWrap) chipWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('.cc-chip');
      if (!chip) return;
      var q = chip.getAttribute('data-q') || '';
      if (input) input.value = q;
      applyFilter(q);
    });

    /* -------- inline media viewer -------- */
    var viewer = root.querySelector('[data-cc-viewer]');
    if (!viewer) { applyFilter(''); return; }

    var vStage = viewer.querySelector('[data-cc-stage]');
    var vModel = viewer.querySelector('[data-cc-v-model]');
    var vMake  = viewer.querySelector('[data-cc-v-make]');
    var vOwner = viewer.querySelector('[data-cc-v-owner]');
    var vLoc   = viewer.querySelector('[data-cc-v-loc]');
    var vIdx   = viewer.querySelector('[data-cc-v-idx]');
    var vClose = viewer.querySelector('[data-cc-v-close]');
    var vPrev  = viewer.querySelector('[data-cc-v-prev]');
    var vNext  = viewer.querySelector('[data-cc-v-next]');

    var cur = { tiles: [], i: 0, make: '', model: '' };
    var lastFocus = null;

    function ytId(url) {
      var m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{6,})/);
      return m ? m[1] : null;
    }
    function vimeoId(url) {
      var m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      return m ? m[1] : null;
    }
    function driveId(url) {
      // Accepts /file/d/ID/..., open?id=ID, uc?id=ID, ?id=ID
      var m = url.match(/\/file\/d\/([\w-]+)/) || url.match(/[?&]id=([\w-]+)/);
      return (url.indexOf('drive.google.com') !== -1 || url.indexOf('docs.google.com') !== -1) && m ? m[1] : null;
    }

    function buildStageMedia(tile) {
      // remove previously injected media (keep nav buttons)
      Array.prototype.slice.call(vStage.querySelectorAll('[data-cc-injected]'))
        .forEach(function (n) { n.remove(); });

      var type   = tile.getAttribute('data-type');
      var poster = tile.getAttribute('data-poster') || '';
      var full   = tile.getAttribute('data-full') || poster;
      var src    = tile.getAttribute('data-video') || '';
      var node;

      if (type === 'video' && src) {
        var yt = ytId(src), vm = vimeoId(src), gd = driveId(src);
        if (gd) {
          node = document.createElement('iframe');
          node.src = 'https://drive.google.com/file/d/' + gd + '/preview';
          node.allow = 'autoplay; fullscreen';
          node.allowFullscreen = true;
        } else if (yt) {
          node = document.createElement('iframe');
          node.src = 'https://www.youtube.com/embed/' + yt + '?autoplay=1&rel=0';
          node.allow = 'autoplay; encrypted-media; picture-in-picture';
          node.allowFullscreen = true;
        } else if (vm) {
          node = document.createElement('iframe');
          node.src = 'https://player.vimeo.com/video/' + vm + '?autoplay=1';
          node.allow = 'autoplay; fullscreen; picture-in-picture';
          node.allowFullscreen = true;
        } else {
          node = document.createElement('video');
          node.src = src;
          node.controls = true; node.autoplay = true; node.playsInline = true;
          if (poster) node.poster = poster;
        }
      } else if (full) {
        node = document.createElement('img');
        node.src = full;
        node.alt = (tile.getAttribute('data-owner') || 'Customer car') + ' — ' + cur.model;
      } else {
        node = document.createElement('div');
        node.className = 'vph';
        node.textContent = (tile.getAttribute('data-label') || 'Media') + ' · ' + (type || 'photo');
      }
      node.setAttribute('data-cc-injected', '');
      vStage.appendChild(node);
    }

    function render() {
      var tile = cur.tiles[cur.i];
      if (!tile) return;
      buildStageMedia(tile);
      if (vModel) vModel.textContent = cur.model;
      if (vMake)  vMake.textContent  = cur.make;
      if (vOwner) vOwner.textContent = tile.getAttribute('data-owner') || '';
      if (vLoc)   vLoc.textContent   = tile.getAttribute('data-loc') || '';
      if (vIdx)   vIdx.textContent   = 'Item ' + (cur.i + 1) + ' of ' + cur.tiles.length;
      var multi = cur.tiles.length > 1;
      if (vPrev) vPrev.style.display = multi ? '' : 'none';
      if (vNext) vNext.style.display = multi ? '' : 'none';
    }

    function open(tile) {
      var group = tile.closest('[data-cc-group]');
      cur.tiles = Array.prototype.slice.call(group.querySelectorAll('[data-cc-tile]'));
      cur.i = cur.tiles.indexOf(tile);
      cur.model = group.getAttribute('data-model') || '';
      cur.make  = group.getAttribute('data-make') || '';
      lastFocus = document.activeElement;
      render();
      viewer.classList.add('show');
      viewer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (vClose) vClose.focus();
    }
    function close() {
      viewer.classList.remove('show');
      viewer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      Array.prototype.slice.call(vStage.querySelectorAll('[data-cc-injected]'))
        .forEach(function (n) { n.remove(); });
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function step(d) {
      if (!cur.tiles.length) return;
      cur.i = (cur.i + d + cur.tiles.length) % cur.tiles.length;
      render();
    }

    gallery.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-cc-tile]');
      if (tile) open(tile);
    });
    if (vClose) vClose.addEventListener('click', close);
    if (vPrev)  vPrev.addEventListener('click', function () { step(-1); });
    if (vNext)  vNext.addEventListener('click', function () { step(1); });
    viewer.addEventListener('click', function (e) { if (e.target === viewer) close(); });
    document.addEventListener('keydown', function (e) {
      if (!viewer.classList.contains('show')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });

    applyFilter('');
  }

  function boot() {
    document.querySelectorAll('[data-cc-root]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Shopify theme editor: re-init on section load
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-cc-root]').forEach(function (r) { r.__ccInit = false; init(r); });
  });
})();
